import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls window to the top whenever the route changes.
// Fixes mobile UX where navigating to a section lands mid-page.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // 'instant' = no smooth animation (feels app-like)
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
